export const saveChainToSs = (chainId: number) => {
  sessionStorage.setItem(
    process.env.REACT_APP_SS_CHAIN_ID_KEY!,
    chainId.toString(),
  );
};
